import { useMediaQuery } from "@vueuse/core";
import { Ref } from "vue";

/**
 * Those breakpoints match the breakpoints found in styles/_breakpoints.scss
 */

const breakpoints: Record<string, number> = {
  screenPhoneMax: 640,
  screenTabletMax: 1024,
  screenUltraWideMin: 2000,
};

interface MediaQueries {
  isMobileScreen: Ref<boolean>;
  isMobileOrTabletScreen: Ref<boolean>;
  isDefaultScreen: Ref<boolean>;
  isUltraWideScreen: Ref<boolean>;
}

export default function useScreenSizes(): MediaQueries {
  return {
    isMobileScreen: useMediaQuery(`(max-width: ${breakpoints.screenPhoneMax}px)`),
    isMobileOrTabletScreen: useMediaQuery(`(max-width: ${breakpoints.screenTabletMax}px)`),
    isDefaultScreen: useMediaQuery(
      `(min-width: ${breakpoints.screenTabletMax + 1}px) and (max-width: ${breakpoints.screenUltraWideMin - 1}px)`
    ),
    isUltraWideScreen: useMediaQuery(`(min-width: ${breakpoints.screenUltraWideMin}px)`),
  };
}
